import { SpeedMessages } from '../messages/speed';
export const SpeedTranslations = SpeedMessages;
